function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 0.5,
  y1: 1.47,
  x2: 0.5,
  y2: 0.382,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#a5119f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ff3067"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 0.5,
  x2: 0.5,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ff3067"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "upload",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4692",
  "data-name": "Group 4692",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3510",
  "data-name": "Path 3510",
  d: "M59.494,73.395H42.536a2.119,2.119,0,0,1-2.12-2.12V62.8a2.119,2.119,0,0,1,2.12-2.12h2.12l-8.479-11.3L27.7,60.676h2.12a2.119,2.119,0,0,1,2.12,2.12v8.479a2.119,2.119,0,0,1-2.12,2.12H12.86a12.708,12.708,0,0,1-2.02-25.277A19.057,19.057,0,0,1,42.515,35.865a14.839,14.839,0,0,1,18.97,12.249,12.708,12.708,0,0,1-1.991,25.281Z",
  transform: "translate(0 -31)",
  fill: "url(#linear-gradient)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_4694",
  "data-name": "Group 4694",
  transform: "translate(21.338 12.766)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4693",
  "data-name": "Group 4693"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3511",
  "data-name": "Path 3511",
  d: "M180.25,139.1l-12.718-16.958a2.2,2.2,0,0,0-3.395,0L151.418,139.1a2.12,2.12,0,0,0,1.7,3.391h4.239v12.9a2.119,2.119,0,0,0,2.12,2.12h12.718a2.119,2.119,0,0,0,2.12-2.12v-12.9h4.239a2.12,2.12,0,0,0,1.7-3.391Zm-8.057,22.645H159.475a2.12,2.12,0,1,0,0,4.239h12.718a2.12,2.12,0,1,0,0-4.239Z",
  transform: "translate(-150.995 -121.337)",
  fill: "url(#linear-gradient-2)"
}))));

function SvgUploadImageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72.35,
    height: 57.41,
    className: "uploadimageicon-svg",
    viewBox: "0 0 72.354 57.409",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImageIcon);
export default __webpack_public_path__ + "static/media/uploadImageIcon.e5a7e57d.svg";
export { ForwardRef as ReactComponent };